import { render, staticRenderFns } from "./NotificationEdit.vue?vue&type=template&id=5a23f00e"
import script from "./NotificationEdit.vue?vue&type=script&lang=js"
export * from "./NotificationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports